export default __webpack_public_path__ + "static/media/Pensamento.747ef169.png";